/** Typed access to Vite-exposed environment variables. */
export const clientEnv = {
  apiBaseUrl: import.meta.env.VITE_API_BASE_URL ?? '/api/v1',
  siteUrl: import.meta.env.VITE_SITE_URL ?? 'http://localhost:5173',
  siteName: import.meta.env.VITE_SITE_NAME ?? 'Resolute Property Solutions',
  /** Hero background video. Self-hosted from /public for reliable playback
   *  (no remote CDN/hotlink variability). Royalty-free placeholder (Pexels
   *  5732002 — aerial luxury villa estate); swap via env/CMS. */
  heroVideoUrl: import.meta.env.VITE_HERO_VIDEO_URL ?? '/hero-villa.mp4',
  /** Optional WebM source (preferred when present for better compression). */
  heroVideoWebmUrl: import.meta.env.VITE_HERO_VIDEO_WEBM_URL ?? '',
} as const;
